<template>
  <component :is="componentName"/>
</template>

<script>
import { i18n } from '@/plugins/i18n'
import { em, iut, law, other, sciencePo } from '@/locales/registrationDates'

export default {
  name: 'router',

  props: {
    lang: {
      required: true,
      type: String,
    },
    population: {
      required: true,
      type: String,
    },
  },

  components: {
    Close: () => import(/**/ '@/components/Close'),
    Researcher: () => import(/* webpackChunkName: "researcher" */ '@/components/Sections/Researcher'),
    PHD: () => import(/* webpackChunkName: "phd" */ '@/components/Sections/PHD'),
    SEPIut: () => import(/* webpackChunkName: "sepIut" */ '@/components/Sections/SEPIut'),
    SEPEM: () => import(/* webpackChunkName: "sepIut" */ '@/components/Sections/SEPEM'),
    SEPOther: () => import(/* webpackChunkName: "sepIut" */ '@/components/Sections/SEPOther'),
    SEPSciencePo: () => import(/* webpackChunkName: "sepIut" */ '@/components/Sections/SEPSciencePo'),
    SEPLaw: () => import(/* webpackChunkName: "sepLaw" */ '@/components/Sections/SEPLaw'),
  },

  data: () => ({
    componentName: '',
  }),

  created () {
    switch (this.population) {
      case 'researcher.html':
        this.componentName = 'Researcher'
        break
      case 'phd.html':
        this.componentName = 'PHD'
        break
      case 'sep-iut.html':
        if (this.formIsOpen(iut)) {
          this.componentName = 'SEPIut'
        } else {
          this.$store.dispatch('setPopulation', 'iut')
          this.componentName = 'Close'
        }
        break
      case 'sep-em.html':
        if (this.formIsOpen(em)) {
          this.componentName = 'SEPEM'
        } else {
          this.$store.dispatch('setPopulation', 'em')
          this.componentName = 'Close'
        }
        break
      case 'sep-other.html':
        if (this.formIsOpen(other)) {
          this.componentName = 'SEPOther'
        } else {
          this.$store.dispatch('setPopulation', 'other')
          this.componentName = 'Close'
        }
        break
      case 'sep-science-po.html':
        if (this.formIsOpen(sciencePo)) {
          this.componentName = 'SEPSciencePo'
        } else {
          this.$store.dispatch('setPopulation', 'sciencePo')
          this.componentName = 'Close'
        }
        break
      case 'sep-law.html':
        if (this.formIsOpen(law)) {
          this.componentName = 'SEPLaw'
        } else {
          this.$store.dispatch('setPopulation', 'law')
          this.componentName = 'Close'
        }
        break
    }
  },

  beforeRouteEnter (to, from, next) {
    const lang = to.params.lang
    if (i18n.locale !== lang) i18n.locale = lang

    return next()
  },

  methods: {
    formIsOpen ({ start, end }) {
      const nowTimestamp = (new Date()).getTime()
      const startTimestamp = (new Date(start)).getTime()
      const endTimestamp = (new Date(end)).getTime()

      return startTimestamp < nowTimestamp && nowTimestamp < endTimestamp
    },
  },
}
</script>
